import { render, staticRenderFns } from "./person_list.vue?vue&type=template&id=3b198c4d&scoped=true"
import script from "./person_list.vue?vue&type=script&lang=js"
export * from "./person_list.vue?vue&type=script&lang=js"
import style0 from "./person_list.vue?vue&type=style&index=0&id=3b198c4d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b198c4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b198c4d')) {
      api.createRecord('3b198c4d', component.options)
    } else {
      api.reload('3b198c4d', component.options)
    }
    module.hot.accept("./person_list.vue?vue&type=template&id=3b198c4d&scoped=true", function () {
      api.rerender('3b198c4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/person_list.vue"
export default component.exports